module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"reported_post":"내가 신고/차단한 게시물"}}')
  delete Component.options._Ctor
}
